import { DadosPagamentoServicoModel } from "@/models/cadastros/assistencia/DadosPagamentoServicoModel";
export class ConfirmacaoSolicitacaoDTO {
  idServico: number;
  idCliente: number;
  idPagamentoCliente: number;
  numeroParcelas: number;
  formaDePagamento: string;
  pagamentoCliente: DadosPagamentoServicoModel;
  constructor(idServico: number, idCliente: number, idPagamentoCliente: number, numeroParcelas: number, formaDePagamento: string, pagamentoCliente: DadosPagamentoServicoModel) {
    this.idServico = idServico;
    this.idCliente = idCliente;
    this.idPagamentoCliente = idPagamentoCliente;
    this.numeroParcelas = numeroParcelas;
    this.formaDePagamento = formaDePagamento;
    this.pagamentoCliente = pagamentoCliente;
  }
}
